export const GUIDE_ELIGIBILITY_REASONS = [
  'verified',
  'verification_rejected',
  'country_not_us',
  'country_unknown',
  'origin_not_allowed',
  'verification_error',
] as const

export type GuideEligibilityReason = (typeof GUIDE_ELIGIBILITY_REASONS)[number]

export interface GuideEligibilityResponse {
  eligible: boolean
  reason: GuideEligibilityReason
}

export const parseGuideEligibility = (value: unknown): GuideEligibilityResponse | null => {
  if (!value || typeof value !== 'object' || !('eligible' in value) || !('reason' in value)) {
    return null
  }
  const { eligible } = value
  const reason = GUIDE_ELIGIBILITY_REASONS.find((candidate) => candidate === value.reason)
  if (typeof eligible !== 'boolean' || !reason) {
    return null
  }
  if (eligible !== (reason === 'verified')) {
    return null
  }
  return { eligible, reason }
}
